<template>
	<div>
		<div class="mt-5">
			<loader />
		</div>
		<warning-box 
      v-if="error_msg != ''"  
      @yes="backToHome"
      :title="$t('warning-message.session_exp.title')"
      :body="error_msg"
      :btn_primary="$t('general.back-to-home')">  
    </warning-box>
	</div>
</template>
<script>
	import {mapGetters, mapMutations,mapActions} from "vuex"
	import {post} from '@/services/index.js'
	import WarningBox from '@/components/general/WarningBox'
	export default{
		components: {
			WarningBox
		},
		data(){
			return{
				error_msg: ''
			}
		},
		computed:{
			session(){
				return this.$route.params.session
			}
		},
		mounted(){
			this.checkSession()
		},
		methods:{
			...mapGetters(['getMerchant','getRestaurantAuth']),
			...mapMutations(['setRestaurantAuth']),
			checkSession(){
				if(this.getRestaurantAuth().session != ''){
					if(this.getRestaurantAuth().session == this.session){
						this.validateSession()
					}else{
						this.endSession()
					}
				}else{
					this.activateSession()
				}
			},
			validateSession(session){
				get("CORE_RESTO", "v2/session/validate",{
			    merchant_id: this.getMerchant().id
				},'restaurant_session').then(response=>{
					let res = response.data;
					if(res.success){
						this.backToHome()
					}else{
						this.setSessionToLocal()
						this.error_msg = res.message
					}
				})
			},
			activateSession(){
				this.setSessionToLocal(this.session)
				post("CORE_RESTO", "v2/session/activate",{
					name: this.$route.query.name ? this.$route.query.name : '',
			    table_number: this.$route.query.table_number ? this.$route.query.table_number : '',
			    merchant_id: this.getMerchant().id
				},'restaurant_session').then(response=>{
					let res = response.data;
					if(res.success){
						this.backToHome()
					}else{
						this.setSessionToLocal()
						this.error_msg = res.message
					}
				})
			},
			endSession(){
				post("CORE_RESTO", "v2/session/close",{},'restaurant_session').then(response=>{
					let res = response.data;
					if(res.success || (!res.success && res.message=='session expired')){
						this.activateSession()
					}else{
						this.error_msg = res.message
					}
				})
			},
			setSessionToLocal(session=''){
				let params = [
					{
						key: 'session',
		    		value: session
					},
				]
				this.setRestaurantAuth(params)
			},
			backToHome(){
				this.$router.push({
					path: '/'+this.getMerchant().code
				})
			}	
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/restaurant/SessionValidate.vue